import module from 'facturacion/facturas/module.js'
import template from './template.html'
import * as moment from 'moment'
import { cloneDeep } from 'lodash'

export class FacturacionFacturarIngresoMasivoComponent {
  data
  catalogos
  timbres = []

  constructor ($q, FacturacionFacturasComprobanteIngresoEmisor, FacturacionFacturasComprobanteIngresoReceptor, FacturacionComprobanteIngresoVistaPrevia, FacturacionComprobanteIngresoNomina) {
    this.$q = $q
    this.FacturacionFacturasComprobanteIngresoEmisor = FacturacionFacturasComprobanteIngresoEmisor
    this.FacturacionFacturasComprobanteIngresoReceptor = FacturacionFacturasComprobanteIngresoReceptor
    this.FacturacionComprobanteIngresoVistaPrevia = FacturacionComprobanteIngresoVistaPrevia
    this.FacturacionComprobanteIngresoNomina = FacturacionComprobanteIngresoNomina
  }

  $onInit () {
    this.promise = this.$q.all([
      this.FacturacionFacturasComprobanteIngresoEmisor.get(this.data.empresa.idEmpresa)
        .then(({data}) => (this.empresa = data)),
      this.FacturacionFacturasComprobanteIngresoReceptor.get(this.data.cliente.idCliente)
        .then(({data}) => (this.cliente = data)),
    ])

    this.data.detalles = this.data.detalles[0]
    this.data.listado = []
    var total
    this.data.detalles.importes.forEach((item) => {
      total = this.data.detalles.cantidad * +item
      this.data.listado.push({
        cantidad: this.data.detalles.cantidad,
        catalogo: this.data.detalles.catalogo,
        clave_servicio_producto_sat: this.data.detalles.clave_servicio_producto_sat,
        clave_unidad_medida_sat: this.data.detalles.clave_unidad_medida_sat,
        descripcion: this.data.detalles.descripcion,
        descripcion_sat_unidad_medida: this.data.detalles.descripcion_sat_unidad_medida,
        factor: this.data.detalles.factor,
        impuestos: this.data.detalles.impuestos.map(impuesto => {
          if (this.data.calcularImpuestos) {
            if (impuesto.traslado === '2') {
              total -= this.data.detalles.cantidad * (+item - this.data.detalles.factor) * (impuesto.valor !== 'Exento' ? parseFloat(impuesto.valor) : 0)
            } else {
              total += this.data.detalles.cantidad * (+item - this.data.detalles.factor) * (impuesto.valor !== 'Exento' ? parseFloat(impuesto.valor) : 0)
            }
          }
          return {
            calculado: this.data.detalles.cantidad * (+item - this.data.detalles.factor) * (impuesto.valor !== 'Exento' ? parseFloat(impuesto.valor) : 0),
            id_concepto: impuesto.id_concepto,
            id_impuesto: impuesto.id_impuesto,
            id_impuesto_tasa_factor: impuesto.id_impuesto_tasa_factor,
            impuesto: impuesto.impuesto,
            traslado: impuesto.traslado,
            valor: impuesto.valor,
          }
        }),
        id: this.data.detalles.id,
        valorUnitario: +item,
        total: total,
      })
    })
    this.data.fechaFormato = moment(this.data.fecha).format('DD MMMM')
    this.data.listado.forEach((item) => {
      let objeto = cloneDeep(this.data)
      objeto.listado = undefined
      item.importes = undefined
      objeto.detalles = [item]
      objeto.timbrado = false
      objeto.error = false
      this.timbres.push(objeto)
    })
    this.step = 1
  }

  organizarNominas () {
    this.timbres.forEach(item => (item.nominas.forEach(nomina => {
      nomina.comision = nomina.comision || 0
      nomina.total = nomina.total || 0
    })))
  }

  timbrar () {
    this.organizarNominas()
    this.timbrarMasivos = true
  }
}

module.component('facturacionFacturarIngresoMasivo', {
  controller: FacturacionFacturarIngresoMasivoComponent,
  template,
  bindings: {
    data: '<',
    catalogos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/facturas/components/ingreso/masivo/component.js